const Education = () => {
  return (
    <>
      <div className="col-lg-12">
        <div className="resume-item">
          <h4>Bachelor's of Chemical Engineering Co-op with Distinction</h4>
          <h5>University of Alberta</h5>
          <h6>
            <ul>
              <li>
                <strong>GPA:</strong>
                <span>3.8/4.0</span>
              </li>
            </ul>
          </h6>
        </div>
        <div className="resume-item">
          <h4>TechCareers Software Development Certificate</h4>
          <h5> Southern Alberta Institute of Technology</h5>
          <h6>
            <ul>
              <li>
                <strong>Technologies: </strong>
                <span>
                  Python, JavaScript, C#, Node.js, SQL, MongoDB, ASP, .NET, AWS,
                  Agile Approach
                </span>
              </li>
            </ul>
          </h6>
        </div>
      </div>
    </>
  );
};

export default Education;
